import type { CustomValues, Metric } from '@atlassian/browser-metrics/types';

export const getMetricEndHelper = (metrics: Metric) => {
	let called = false;
	return (result: 'cancel' | 'stop', customData?: Record<string, unknown>): void => {
		if (!called) {
			if (result === 'stop') {
				metrics.stop({ customData: customData as CustomValues });
			} else {
				metrics.cancel();
			}
			called = true;
		}
	};
};
